import { useEffect } from 'react';
import LogRocket from 'logrocket';

const logRocketReturnsPageVisitEventName = 'VISIT_RETURN_SHIPMENTS_GRID';

let hasTrackedVisit = false;

export const useTrackReturnShipmentsGridVisit = (): void => {
  useEffect(() => {
    if (hasTrackedVisit) {
      return;
    }
    hasTrackedVisit = true;

    const environment = process.env.NODE_ENV || 'development';
    LogRocket.track(logRocketReturnsPageVisitEventName, {
      env: environment,
    });
  }, []);
};
